function RewardSecFive() {
    return (
        <>
          <div className="as_ifyouwant_mainwrapper">
                <div className="as_ifyouwant_subwrapper1">
                    <div className="share4rewards-container">
                        <div className="as_greentitle">
                            <h3>If you Want to know more about our ANS Health Risk Exam</h3>
                        </div>
                        <div className="as_textwrapper">
                            <div className="as_yellowtitle">
                                <h2>WHY OUR HEALTH RISK EXAM?</h2>
                            </div>

                             

                            <p>
                                <span> Our Health Risk Exam is FDA cleared </span> and covered by most insurance, including Medicare. This means most of your customers will qualify to have the cost covered! We use the latest technology in early disease detection available on the market.
                                </p>
                            
                                <p>
                                Regular doctor practices, even if they do blood labs, do not have the ability to test for all of these disease risks without extensive testing. <span> Often, these health risks go unnoticed in a regular doctor visit examination. </span>
                               <b> Many diseases and sudden early deaths are due to catching undetected diseases at later stages when it is too late. </b>
                                Our early detection exam covers over 20 potential disease states (see below for full list) in just 15 minutes.
                                </p>



                                
                               
                                
                                <p>
                                The CDC states in the United States, someone has a heart attack every 40 seconds.
                                <strong> Every year, about 805,000 people in the US have a heart attack. 75% of these are first heart attacks!</strong> 
                                We are able to catch evidence of problems leading to heart attack up to 2 years early. Certainly, in time to make a big difference in the future wellbeing of someone that you shared our information with.
                                </p>

                                <p>
                                <span> According to the CDC, nearly 900,000 Americans </span>
                                die prematurely each year. Up to 40% of these deaths could have been prevented! Breakthroughs in the last decade in early detection have advanced medical professionals' ability to detect disease early. We are one of the few facilities that have adapted to this new detection technology. Helping us get the word out could quite literally save one of your customers’ lives!
                                </p>
                               
                            
                        </div>
                    </div>
                </div>
                {/* <div className="as_ifyouwant_subwrapper2">
                    <div className="share4rewards-container">
                        <div className="as_textwrapper">
                            <div className="as_yellowtitle">
                                <h2>Common Symptoms of Health Risk.</h2>
                            </div>
                                <p>
                                <span>We work with the latest cutting edge science! </span> 
                                If any of your customers have one or several of the following symptoms, don’t hesitate and advise them to come see our friendly and knowledgeable medical team. These common symptoms could be more serious than you think. Early detection could even save the life of a patient.
                                </p>
                                <p>
                                <b>These common symptoms could be more serious than you think. Early detection could even save your life or that of a loved one. Your customers will thank you for sharing our information with them!</b>
                                </p>
                        </div>
                    </div>
                </div> */}
          </div>
          
        </>
    )
}

export default RewardSecFive;